/**
 * @generated SignedSource<<b10e48b5729165c68d9713d0d5a8ab63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type academiesTags_Query$variables = {};
export type academiesTags_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"academiesTagsTable_QueryFragment">;
};
export type academiesTags_Query = {
  response: academiesTags_Query$data;
  variables: academiesTags_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canBeDeleted",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isClickable",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTopic",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "AcademiesTagData",
  "kind": "LinkedField",
  "name": "data",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "academiesTags_Query",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "academiesTagsTable_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "academiesTags_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AcademiesTagAdminSchema",
            "kind": "LinkedField",
            "name": "AcademiesTag",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AcademiesRootTagsConnection",
                "kind": "LinkedField",
                "name": "RootTags",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AcademiesRootTagsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AcademiesRootTag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AcademiesChildTagsConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AcademiesChildTagsEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AcademiesChildTag",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v0/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "AcademiesTagData",
                                                "kind": "LinkedField",
                                                "name": "data",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  (v5/*: any*/),
                                                  (v4/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v2/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "subId",
                                                "storageKey": null
                                              },
                                              (v1/*: any*/),
                                              {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isAcademiesTag"
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "AcademiesRootTag",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v6/*: any*/)
                                ],
                                "type": "AcademiesChildTag",
                                "abstractKey": null
                              }
                            ],
                            "type": "AcademiesTag",
                            "abstractKey": "__isAcademiesTag"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "filters": [
                  "name",
                  "isClickable",
                  "isTopic"
                ],
                "handle": "connection",
                "key": "academiesTagsTable_RootTags",
                "kind": "LinkedHandle",
                "name": "RootTags"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b7a659a7622261a49622cd30a5b530ae",
    "id": null,
    "metadata": {},
    "name": "academiesTags_Query",
    "operationKind": "query",
    "text": "query academiesTags_Query {\n  ...academiesTagsTable_QueryFragment\n}\n\nfragment academiesTagsTable_AcademiesTagFragment on AcademiesTag {\n  __isAcademiesTag: __typename\n  id\n  ... on AcademiesRootTag {\n    kind\n    canBeDeleted\n    data {\n      name\n      isClickable\n      isTopic\n    }\n    children {\n      edges {\n        node {\n          id\n          data {\n            name\n            isTopic\n            isClickable\n          }\n          canBeDeleted\n          subId\n          kind\n          ...editAcademiesTagButton_AcademiesTagFragment\n        }\n      }\n    }\n  }\n  ...editAcademiesTagButton_AcademiesTagFragment\n}\n\nfragment academiesTagsTable_QueryFragment on Query {\n  Admin {\n    AcademiesTag {\n      RootTags {\n        edges {\n          node {\n            ...academiesTagsTable_AcademiesTagFragment\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n          hasPreviousPage\n          startCursor\n        }\n      }\n    }\n  }\n}\n\nfragment editAcademiesTagButton_AcademiesTagFragment on AcademiesTag {\n  __isAcademiesTag: __typename\n  id\n  ... on AcademiesRootTag {\n    data {\n      name\n      isTopic\n      isClickable\n    }\n  }\n  ... on AcademiesChildTag {\n    data {\n      name\n      isClickable\n      isTopic\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "07bd1b14675265cadc86a7c698759f22";

export default node;
